import { Box, Tooltip } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { isNil } from 'ramda';
import { useTranslation } from 'react-i18next';
import { Union } from 'ts-toolbelt';

import { I18nNamespace } from '~/common/types';
import { NULLISH_CELL_VALUE } from '~/components/DataGridCustom/DataGridCustom.types';

import { LinearProgressStyled } from './LinearProgressCell.styled';
import { getProgressColor } from './LinearProgressCell.util';

export type LinearProgressCellValue = Union.Nullable<number>;

interface LinearProgressCellProps<R extends GridValidRowModel = any> {
  value: LinearProgressCellValue;
  row: R;
}

export const LinearProgressCell = <R extends GridValidRowModel = any>({ value }: LinearProgressCellProps<R>) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'UserAvailabilityWidget.cell.linearProgress' });
  if (!isNil(value)) {
    return (
      <Box sx={{ width: '100%' }}>
        <Tooltip title={t('tooltip', { value })}>
          <LinearProgressStyled variant="determinate" value={value * 100} color={getProgressColor(value)} />
        </Tooltip>
      </Box>
    );
  }
  return <>{NULLISH_CELL_VALUE}</>;
};
